import { StyleSheet, Text, View } from './components/base_components';
import BusyComponent from './components/busy_component';

import UserStore from './stores/user_store';

import WideButton from './components/buttons/wide_button';

const styles = StyleSheet.create({
  accountScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
});

type Props = {
  history: any;
};
type State = {};

export default class AccountScreen extends BusyComponent<Props, State> {
  componentDidMount() {
    if (!UserStore.isLoggedIn()) {
      this.props.history.replace('/login');
    }
  }

  _onLogoutPress = () => {
    if (this.setBusy()) {
      UserStore.logout(() => {
        this.clearBusy();
        this.props.history.replace('/');
      });
    }
  };

  render() {
    const user = UserStore.getPlayerData();
    return (
      <View style={styles.accountScreen}>
        <Text style={styles.text}>User:{user.name}</Text>
        <WideButton
          style={styles.button}
          text='Logout'
          onPress={this._onLogoutPress}
        />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
